<template>
    <el-row>
     <el-col :span="24" v-if="$route.query.flag === undefined || $route.query.flag === true || ($route.query.flag === false && list.length)">
        <div style="display: flex; justify-content: space-between;">
         <div class="fileList">公共附件</div>
         <div v-if="$route.query.flag !== false">
          <el-button style="margin-top:10px" type="primary" size='small' @click="visible=true">新建</el-button>
         </div>
        </div>
         <STable v-if="dataId" :columns="columns" :loadData="loadData" ref="table" :showSize ='false' :tooltip='false'>
           <template #sn='{ $index }'>
             {{ $index + 1 }}
           </template>
           <template #fileUrl="record">
              <a href="javascript:;" @click="handleDownload(record.row.id, record.row)">{{record.row.fileUrl}}</a>
           </template>
           <template #action="record">
              <a v-if="initUserInfo().userId == record.row.createUserId" class="delete" href="javascript:;" @click="handleDelete(record.row)">删除</a>
           </template>
         </STable>
     </el-col>
     <FileDialog :dataId='dataId' :visible.sync="visible" @handleReceive='handleReceive' />
    </el-row>
</template>

<script>
import STable from '@/components/STable';
import FileDialog from './fileDialog.vue';
import projectConfig from '@/core/config';
import { File } from '@/api/file';
import { initUserInfo } from '@/store/utils';

export default {
  name: 'fileModule',
  props: {
    dataId: {
      type: [String, Number]
    }
  },
  components: {
    STable,
    FileDialog
  },
  data () {
    return {
      initUserInfo,
      columns: [
        {
          label: '序号',
          scopedSlots: 'sn',
          width: 70
        },
        {
          label: '上传人',
          prop: 'createUserName'
        },
        {
          label: '部门',
          prop: 'deptName'
        },
        {
          label: '附件名称',
          prop: 'fileName'
        },
        {
          label: '附件地址',
          scopedSlots: 'fileUrl'
        },
        {
          label: '操作',
          scopedSlots: 'action',
          width: 150,
          fixed: 'right'
        }
      ],
      list: [],
      loadData: (pageParam) => {
        if (!this.dataId) return
        const oaFileDtoFilter = {
          dataId: this.dataId
        }
        return File.getList(this, {
          oaFileDtoFilter,
          pageParam
        }).then(rs => rs)
      },
      visible: false,
      token: localStorage.getItem('token')
    }
  },
  watch:{
    dataId(val){
      const oaFileDtoFilter = {
        dataId: val
      }
      File.getList(this, {
        oaFileDtoFilter
      }).then(rs => {
        this.list = rs.data.dataList
      })
    }
  },
  created () {
    if (this.$route.query.flag === false) {
      this.columns = [
        {
          label: '序号',
          scopedSlots: 'sn',
          width: 70
        },
        {
          label: '上传人',
          prop: 'createUserName'
        },
        {
          label: '部门',
          prop: 'deptName'
        },
        {
          label: '附件名称',
          prop: 'fileName'
        },
        {
          label: '附件地址',
          scopedSlots: 'fileUrl'
        }
      ]
    } else {
      this.columns = [
        {
          label: '序号',
          scopedSlots: 'sn',
          width: 70
        },
        {
          label: '上传人',
          prop: 'createUserName'
        },
        {
          label: '部门',
          prop: 'deptName'
        },
        {
          label: '附件名称',
          prop: 'fileName'
        },
        {
          label: '附件地址',
          scopedSlots: 'fileUrl'
        },
        {
          label: '操作',
          scopedSlots: 'action',
          width: 150,
          fixed: 'right'
        }
      ]
    }
  },
  methods: {
    handleReceive (flag = true) {
      if (this.$refs.table) this.$refs.table.refresh(flag)
    },
    handleDelete (record) {
      File.deleteFile(this, {id: record.id}).then(res => {
        this.$message({
          message: '删除成功',
          type: 'success'
        });
        this.handleReceive(false)
      })
    },
    handleDownload (id, record) {
      const name = record.fileUrl
      const url = projectConfig.baseUrl + 'admin/online/onlineOperation/downloadDatasource/oaFile?datasourceId=1633723237428891648&fieldName=FILE_URL&asImage=false&dataId=' + id + '&filename=' + name + '&Authorization=' + this.token + '&MenuId=1633724000125325312'
      this.downloadFile(url, record.fileName).then(res => {
      })
    }
  }
}

</script>

<style lang='scss' scoped>
.fileList{
  position: relative;
  margin: 15px 8px;
  font-size: 16px;
  font-weight: 800;
}
.fileList::before{
  content: '';
  display: inline-block;
  width: 3px;
  height: 23px;
  background-color:rgb(64, 158, 255);
  position: absolute;
  left: -8px;
  top:0px
}
</style>
